import { differenceInDays } from 'date-fns';
import { darken, lighten } from 'polished';
import React from 'react';
import { useLocalStorage } from 'react-use';
import { styled } from 'styled-components';
import { Icon } from '../../concepts/resources/Icon';
import { Colors } from '../../ui';
import { useResolve } from '../Container';
import { ProfileModel } from '../ProfileModel';
import { Copy } from '../dashboard/elements/LayoutElements';

const EmailVerifyPill = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: .5rem;
    padding: .5rem .5rem .5rem .75rem;
    margin-right: 1rem;
    background: ${Colors.mystery};
    color: white;
    border-radius: 1.5rem;

    &:hover {
        background: ${darken(0.05, Colors.mystery)};
    }

    &:active {
        background: ${darken(0.1, Colors.mystery)};
    }

    ${Copy} {
        color: white;
    }
`;

const CloseButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 50%;
    padding: .25rem;
    &:hover {
        background: ${lighten(0.05, Colors.mystery)};
    }
`;

const isNextDay = (date: Date) => {
    return differenceInDays(new Date(), date) >= 1;
};

export const EmailVerifyHeader = () => {
    const me = useResolve(ProfileModel);
    if (me.emailVerified) return null;

    const days = 7 - differenceInDays(new Date(), me.createdAt);
    const [dismiss, setDismiss] = useLocalStorage('deqo/ui/emailVerifyDismiss', null);

    if (!isNextDay(new Date(dismiss))) return null;

    return <a href="/account/verify-email" target="_blank">
        <EmailVerifyPill>
            <Icon size="1.7" src="deqo://icons/i8/email" />
            <Copy flush whiteSpace="nowrap">
                {days} more days to verify email
            </Copy>
            <CloseButton onClick={() => setDismiss(new Date().toISOString())}>
                <Icon size="1" src="deqo://icons/hero/x" />
            </CloseButton>
        </EmailVerifyPill>
    </a>;
};
